export default "__VITE_PUBLIC_ASSET__67df6992__"